import { fork, takeEvery, all, put } from 'redux-saga/effects';

import config from '../../../config/config';
import { PerplayGameApi } from '../../models/src';
import BaseResponse from '../../models/src/model/BaseResponse';
import {
  ITEM_DB_INFO_REQUEST,
  ITEM_DB_UPDATE,
} from '../../constants/app/itemDBConstants';
import GameControllerDtoMaterialConfigInfoResponse
  from '../../models/src/model/GameControllerDtoMaterialConfigInfoResponse';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import {setItemConfig} from "../../actions/app/itemDBActions";

const api = new PerplayGameApi(config.API_CLIENT);

function* itemDBUpdateSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.'
  });

  try {
    console.log('요청 데이터: ', payload.ConfigFile);
    const result = yield api.apiPerplayGameMaterialConfigUpdatePost(payload.ConfigFile, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* itemDBInfoRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback 설정되지 않았습니다.'
  });

  try {
    console.log('리스트 요청 ! ! !');
    const result = yield api.apiPerplayGameMaterialConfigInfoPost(() => {});
    const data = api.apiClient.deserialize(result, GameControllerDtoMaterialConfigInfoResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    yield put(setItemConfig(data.materials));
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* itemDBRootSaga() {
  yield all([
    takeEvery(ITEM_DB_UPDATE, itemDBUpdateSaga),
    takeEvery(ITEM_DB_INFO_REQUEST, itemDBInfoRequestSaga),
  ]);
}

const itemDBSagas = [fork(itemDBRootSaga)];

export default itemDBSagas;
